/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Position_Theoretical_DescriptionInputs */

const fr_help_position_theoretical_description = /** @type {(inputs: Help_Position_Theoretical_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horaires sans aucun temps réel`)
};

const en_help_position_theoretical_description = /** @type {(inputs: Help_Position_Theoretical_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedules without any real-time data`)
};

/**
* | output |
* | --- |
* | "Schedules without any real-time data" |
*
* @param {Help_Position_Theoretical_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_position_theoretical_description = /** @type {((inputs?: Help_Position_Theoretical_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Position_Theoretical_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_position_theoretical_description(inputs)
	return en_help_position_theoretical_description(inputs)
});